import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg"

const IconeSuiviFichePatient = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={57} height={57} fill="none" viewBox="0 0 57 57" {...props}>
            <Rect width={57} height={57} fill="#fff" rx={10} />
            <G clipPath="url(#clip0)">
                <Path
                    fill={baseColors.green.primary}
                    d="M42 28.5c0 1.997-.434 3.892-1.212 5.598a13.554 13.554 0 01-6.566 6.633 13.377 13.377 0 01-3.584 1.1 13.42 13.42 0 01-2.782.154c-.096-.005-.193-.01-.289-.017l-.215-.016a13.39 13.39 0 01-3.483-.767 13.32 13.32 0 01-2.354-1.132 13.57 13.57 0 01-5.357-6.075A13.446 13.446 0 0115 28.5C15 21.044 21.044 15 28.5 15S42 21.044 42 28.5z"
                />
                <Path
                    fill="#2BA1CF"
                    d="M25.86 32.52v9.221a13.322 13.322 0 01-4.345-1.688 13.572 13.572 0 01-5.357-6.075V32.52a3.66 3.66 0 013.659-3.659H22.2a3.637 3.637 0 01.945.123l.003.001c.412.11.795.29 1.136.528a3.653 3.653 0 011.576 3.007z"
                />
                <Path
                    fill="#66BAED"
                    d="M25.86 32.52v9.221a13.322 13.322 0 01-4.345-1.688 13.573 13.573 0 01-3.786-3.414v-4.12a3.66 3.66 0 013.659-3.659h.812a3.637 3.637 0 01.945.123l.003.001c.412.11.795.29 1.136.528a3.653 3.653 0 011.576 3.007z"
                />
                <Path
                    fill="#F2F0EC"
                    d="M23.157 28.943l-.009.042-1.094 5.09c-.105.49-.536.845-1.036.845h-.019c-.5 0-.93-.355-1.035-.844l-1.095-5.09-.009-.043h4.297z"
                />
                <Path
                    fill="#D8D5D0"
                    d="M21.009 30.358l-1.648.915-.5-2.33 1.023-.603m1.125 2.018l1.647.915.501-2.33-1.024-.603"
                />
                <Path
                    fill="#CC7A3B"
                    d="M16.09 27.978V22.46c0-.56.094-1.11.278-1.633a4.925 4.925 0 015.407-3.227 4.92 4.92 0 014.153 4.86v5.518"
                />
                <Path
                    fill="#A35418"
                    d="M18.114 22.676c0 1.952 1.143 4.21 1.77 5.303H16.09V22.46c0-.561.094-1.11.278-1.633a4.924 4.924 0 014.605-3.286c-1.512.038-2.86 2.464-2.86 5.134z"
                />
                <Path fill="#EAB599" d="M22.314 27.451v1.602a1.305 1.305 0 11-2.61 0v-1.602h2.61z" />
                <Path
                    fill="#F6CAAE"
                    d="M22.314 28.951v.102c0 .586-.386 1.082-.919 1.247a1.305 1.305 0 01-.909-1.077 4.472 4.472 0 001.828-.271zm-4.886-4.126a1.214 1.214 0 11-2.428 0 1.214 1.214 0 012.428 0z"
                />
                <Path
                    fill="#EAB599"
                    d="M17.428 24.825c0 .605-.441 1.106-1.02 1.199a4.521 4.521 0 010-2.397c.579.093 1.02.594 1.02 1.198z"
                />
                <Path fill="#EAB599" d="M16.648 24.825a.434.434 0 11-.868 0 .434.434 0 01.868 0z" />
                <Path
                    fill="#EAB599"
                    d="M24.126 23.275v4.173a4.5 4.5 0 01-2.392 1.19l-.022.004a4.517 4.517 0 01-5.22-4.462v-1.72c0-.22.016-.437.046-.649 1.075.773 2.616.697 3.598-.23.325-.308.55-.674.678-1.061.071.679.382 1.34.933 1.86a3.333 3.333 0 002.38.895z"
                />
                <Path
                    fill="#F6CAAE"
                    d="M24.126 23.275v4.173a4.5 4.5 0 01-2.392 1.19l-.022.004a4.518 4.518 0 01-3.813-4.462v-1.72c0-.046 0-.091.002-.136a2.83 2.83 0 002.235-.744c.325-.307.55-.673.678-1.06.071.679.382 1.34.933 1.86a3.333 3.333 0 002.38.895z"
                />
                <Path fill="#EAB599" d="M23.435 23.8a.75.75 0 10-1.5 0m-1.851 0a.75.75 0 10-1.5 0" />
                <Path
                    fill="#3D4159"
                    d="M19.846 24.118a.513.513 0 11-1.025 0 .513.513 0 011.025 0zm3.351 0a.512.512 0 11-1.025 0 .512.512 0 011.025 0z"
                />
                <Path
                    fill="#EAB599"
                    d="M21.522 25.408h-1.025a.221.221 0 010-.442h1.025a.221.221 0 010 .442zm-.512 1.399a2.29 2.29 0 01-1.102-.284.2.2 0 11.194-.353 1.875 1.875 0 001.815 0 .201.201 0 01.194.352c-.345.19-.724.285-1.102.285z"
                />
                <Path
                    fill="#fff"
                    d="M19.742 24.027a.22.22 0 11-.44 0 .22.22 0 01.44 0zm3.376 0a.22.22 0 11-.44 0 .22.22 0 01.44 0z"
                />
                <Path
                    fill="#EAB599"
                    d="M24.084 25.366a.563.563 0 11-1.126 0 .563.563 0 011.126 0zm-5.024 0a.563.563 0 11-1.125 0 .563.563 0 011.125 0z"
                />
                <Path
                    fill="#BFD5DE"
                    d="M40.788 32.407v1.69a13.554 13.554 0 01-6.566 6.634c-.525.245-1.069.459-1.629.636a13.224 13.224 0 01-1.955.463v-9.423a3.827 3.827 0 013.828-3.827h2.493a3.83 3.83 0 013.83 3.827z"
                />
                <Path
                    fill="#DDE8ED"
                    d="M40.788 32.407v1.69a13.554 13.554 0 01-6.566 6.634c-.525.245-1.069.459-1.629.636v-8.96a3.828 3.828 0 013.83-3.827h.537a3.828 3.828 0 013.828 3.827z"
                />
                <Path fill="#D3A489" d="M31.966 24.358a1.27 1.27 0 11-2.54 0 1.27 1.27 0 012.54 0z" />
                <Path fill="#F74F4F" d="M36.741 29.96l-1.028 1.65-1.028-1.65" />
                <Path fill="#F74F4F" d="M37.096 36.266l-1.383 1.745-1.383-1.745 1.384-5.085 1.382 5.085z" />
                <Path
                    fill="#BF8E75"
                    d="M31.966 24.358a1.27 1.27 0 01-1.066 1.254 4.725 4.725 0 010-2.507 1.27 1.27 0 011.067 1.253z"
                />
                <Path fill="#BF8E75" d="M31.15 24.358a.454.454 0 11-.908 0 .454.454 0 01.908 0z" />
                <Path
                    fill="#BFD5DE"
                    d="M35.713 30.148l-1.723.958-.525-2.44 1.071-.63m1.177 2.112l1.723.958.525-2.44-1.071-.63"
                />
                <Path fill="#D3A489" d="M39.46 24.358a1.27 1.27 0 102.54 0 1.27 1.27 0 00-2.54 0z" />
                <Path
                    fill="#BF8E75"
                    d="M39.46 24.358a1.27 1.27 0 001.066 1.254 4.717 4.717 0 000-2.507 1.27 1.27 0 00-1.066 1.253z"
                />
                <Path fill="#BF8E75" d="M41.184 24.36a.454.454 0 11-.908-.001.454.454 0 01.908 0z" />
                <Path
                    fill="#BF8E75"
                    d="M40.439 23.684a4.726 4.726 0 01-9.452 0c0-1.235.43-3.089 1.205-3.93.863-.938 2.146-.796 3.521-.796a4.726 4.726 0 014.726 4.726z"
                />
                <Path fill="#BF8E75" d="M37.08 27.106v1.677a1.366 1.366 0 11-2.733 0v-1.677h2.732z" />
                <Path
                    fill="#D3A489"
                    d="M37.079 28.676v.106c0 .614-.404 1.132-.962 1.305a1.365 1.365 0 01-.95-1.127 4.693 4.693 0 001.913-.284zm3.36-4.993a4.726 4.726 0 01-3.968 4.665 4.726 4.726 0 010-9.33 4.727 4.727 0 013.968 4.665z"
                />
                <Path
                    fill="#BF8E75"
                    d="M35.713 26.011a2.39 2.39 0 01-1.152-.297.21.21 0 11.203-.368 1.963 1.963 0 001.899 0 .21.21 0 11.202.368c-.36.198-.756.297-1.152.297z"
                />
                <Path
                    fill="#3D4159"
                    d="M34.707 23.408a.536.536 0 11-1.072 0 .536.536 0 011.072 0zm3.085 0a.536.536 0 11-1.072 0 .536.536 0 011.072 0z"
                />
                <Path
                    fill="#fff"
                    d="M34.597 23.314a.23.23 0 11-.46 0 .23.23 0 01.46 0zm3.112 0a.23.23 0 11-.46 0 .23.23 0 01.46 0z"
                />
                <Path fill="#BF8E75" d="M36.25 24.758h-1.073a.231.231 0 010-.462h1.072a.231.231 0 110 .462z" />
                <Path fill="#BFD5DE" d="M37.27 32.282h2.06v.63h-2.06v-.63z" />
                <Path
                    fill="#2A2F4F"
                    d="M35.437 17.607a2.864 2.864 0 012.654 2.714l.013.274h.824l.443 2.95 1.074-.333-.144-2.89A2.864 2.864 0 0037.43 17.6l-1.993.007z"
                />
                <Path fill="#3D4159" d="M40.21 16.467a2.92 2.92 0 11-4.128 4.128l4.128-4.128z" />
                <Path
                    fill="#3D4159"
                    d="M36.082 20.595h-3.583l-.444 2.95-1.074-.333.144-2.89a2.865 2.865 0 012.872-2.722l5.174.02.684 1.23"
                />
                <Path
                    fill="#2A2F4F"
                    d="M35.99 17.607a2.864 2.864 0 00-2.654 2.714l-.014.274H32.5l-.444 2.95-1.074-.333.144-2.89a2.864 2.864 0 012.872-2.722l1.993.007z"
                />
                <Path
                    fill="#3D4159"
                    d="M34.222 39.72v1.011a13.452 13.452 0 01-5.722 1.27c-2.046 0-3.985-.456-5.723-1.27v-1.012a4.317 4.317 0 014.317-4.317h2.811a4.323 4.323 0 011.115.145l.004.001c.486.13.938.343 1.34.622a4.31 4.31 0 011.858 3.55z"
                />
                <Path
                    fill="#66BAED"
                    d="M31.034 35.499l-.01.049-1.377 6.404a15.012 15.012 0 01-.519.033 13.226 13.226 0 01-1.776-.033l-1.377-6.403-.01-.05h5.07z"
                />
                <Path fill="#3D4159" d="M29.659 36.96l-1.16 1.858-1.158-1.858" />
                <Path
                    fill="#3D4159"
                    d="M29.432 41.968A15.042 15.042 0 0128.5 42a13.077 13.077 0 01-.933-.032l.933-3.633.932 3.633z"
                />
                <Path
                    fill="#2BA1CF"
                    d="M28.5 37.17l-1.944 1.08-.591-2.75 1.207-.712M28.5 37.17l1.943 1.08.59-2.75-1.207-.712"
                />
                <Path
                    fill="#2A2F4F"
                    d="M31.107 39.21h.617l-1.077 2.62c-.498.08-1.005.132-1.519.155l1.892-6.438.014-.048 1.33.434-1.257 3.277zm-3.25 2.774a13.362 13.362 0 01-1.52-.157L25.26 39.21h.616l-1.257-3.277 1.33-.434.015.048 1.892 6.438z"
                />
                <Path fill="#EAB599" d="M30.04 33.74v1.89a1.54 1.54 0 11-3.08 0v-1.89h3.08z" />
                <Path
                    fill="#F6CAAE"
                    d="M30.04 35.51v.12a1.54 1.54 0 01-1.085 1.47 1.54 1.54 0 01-1.072-1.27 5.295 5.295 0 002.157-.32zm-5.765-4.868a1.433 1.433 0 11-2.866-.001 1.433 1.433 0 012.866 0z"
                />
                <Path
                    fill="#EAB599"
                    d="M24.275 30.642c0 .712-.521 1.304-1.203 1.413a5.33 5.33 0 010-2.828c.682.11 1.203.701 1.203 1.415z"
                />
                <Path fill="#EAB599" d="M23.354 30.642a.512.512 0 11-1.024 0 .512.512 0 011.024 0z" />
                <Path fill="#F6CAAE" d="M32.724 30.642a1.433 1.433 0 102.866 0 1.433 1.433 0 00-2.866 0z" />
                <Path
                    fill="#EAB599"
                    d="M32.724 30.642c0 .712.521 1.304 1.203 1.413a5.33 5.33 0 000-2.828 1.433 1.433 0 00-1.203 1.415z"
                />
                <Path
                    fill="#EAB599"
                    d="M33.829 27.85v2.03a5.329 5.329 0 01-4.474 5.26l-.026.004a5.329 5.329 0 01-6.158-5.264v-2.03a5.33 5.33 0 015.329-5.33 5.33 5.33 0 015.329 5.33z"
                />
                <Path fill="#EAB599" d="M34.668 30.642a.512.512 0 11-1.023 0 .512.512 0 011.023 0z" />
                <Path
                    fill="#F6CAAE"
                    d="M33.828 27.85v2.03a5.33 5.33 0 01-4.473 5.26l-.026.004a5.33 5.33 0 01-4.499-5.264v-2.03a5.33 5.33 0 014.5-5.264 5.33 5.33 0 014.498 5.265z"
                />
                <Path
                    fill="#3D4159"
                    d="M27.365 29.57a.605.605 0 11-1.21 0 .605.605 0 011.21 0zm3.479 0a.605.605 0 11-1.21 0 .605.605 0 011.21 0z"
                />
                <Path
                    fill="#fff"
                    d="M27.241 29.463a.259.259 0 11-.518 0 .259.259 0 01.518 0zm3.509 0a.259.259 0 11-.518 0 .259.259 0 01.518 0z"
                />
                <Path
                    fill="#EAB599"
                    d="M29.104 30.856h-1.21a.26.26 0 010-.522h1.21a.26.26 0 110 .522zm-.604 1.649c-.447 0-.893-.112-1.3-.336a.237.237 0 11.229-.415c.67.369 1.47.369 2.141 0a.237.237 0 11.229.415 2.692 2.692 0 01-1.3.336z"
                />
                <Path
                    fill="#2A2F4F"
                    d="M33.829 26.01v2.078h-.992V26.46l-7.16-1.33-1.515-.282v3.24h-.991V26.01a4.29 4.29 0 014.29-4.29h2.078a4.29 4.29 0 014.29 4.29z"
                />
                <Path
                    fill="#3D4159"
                    d="M33.829 26.01v2.078h-.992V26.46l-7.16-1.33a4.29 4.29 0 014.03-3.407 4.29 4.29 0 014.122 4.286z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0">
                    <Path fill="#fff" d="M0 0h27v27H0z" transform="translate(15 15)" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default IconeSuiviFichePatient
